import axios from 'axios';

// API URL'sini local Strapi sunucusuna yönlendir
export const API_URL = 'https://api.monaklinik.com';

// API istemcisi oluştur
const apiClient = axios.create({
    baseURL: `${API_URL}/api`,
    headers: {
        'Content-Type': 'application/json',
    }
});

// İstek hatalarını yakalama
apiClient.interceptors.response.use(
    response => response,
    error => {
        console.error('API İsteği Hatası:', error);
        return Promise.reject(error);
    }
);

export default apiClient;
